module.exports = __webpack_public_path__ + "img/Search.7202594d.svg";